// extracted by mini-css-extract-plugin
export default {"page":"styles_page__mHLXh","pageForm":"styles_pageForm__CsmkJ","pageLoader":"styles_pageLoader__MUgAD"};